<template>
  <!--  have to have dynamic style because main area needs to get squished if the nav menu also has multi org -->
  <v-main :style="!isMobile && isMultiOrg ? 'padding-left: 334px' : null">
    <!--    below is a dummy div to hold the spacing that the breadcrumbs used to take to prevent heavy CSS refactoring-->
    <div
      v-if="$route.name !== 'Live Events'"
      style="height:76px"
    />
    <toaster-container />
    <router-view />
  </v-main>
</template>

<script>
  import ToasterContainer from '@/components/base/ToasterContainer'
  import { mapGetters } from 'vuex'
  export default {
    name: 'DashboardCoreView',
    components: {
      ToasterContainer,
    },
    computed: {
      ...mapGetters({ isMultiOrg: 'Permissions/isMultiOrg' }),
      isMobile () {
        return this.$vuetify.breakpoint.mobile
      },
    },
  }
</script>
<style lang="scss">
.theme--light.v-application {
  background-color: $na-off-white;
}
.toaster-container {
  margin-top: 100px;
}
.na-toaster {
  font-size: 16px;
  font-family: "Degular", sans-serif;
  font-weight: 400;
  color: white;
}
</style>
